import React, {useEffect, useState} from 'react';
import {Days} from "../../Store/days/days";
import {isVoted, getVotes, saveVote} from "../../api/requests";

const Modal = ({day, setModal, setLastOpenedBox, voteId}) => {
    const [content] = useState(Days.filter(item => item.id === parseInt(day)));
    const [voted, setVoted] = useState(true);
    const [votes, setVotes] = useState([0, 0]);

    useEffect(() => {
        window.scrollTo(0, 0);
        isVoted(day, isVotedResponseHandler);
        getVotes(day, (res) => {
            setVotes([res.data.votes0, res.data.votes1])
        });
    }, []);

    const isVotedResponseHandler = (res) => {
        setVoted(res.data.isVoted);
    };

    const vote = (option) => {
        saveVote(day, option);
        setVoted(true);
        setVotes(prev => {
            const next = [...prev];
            next[option] = next[option] + 1;
            return next;
        });
    }

    const total = votes[0] + votes[1];
    const percent0 = total === 0 ? 0 : (votes[0] / total) * 100;
    const percent1 = total === 0 ? 0 : (votes[1] / total) * 100;

    return (
        <>
            <div
                className={'absolute flex justify-center items-center left-0 right-0 top-0 min-h-screen z-[150] bg-black/80 md:fixed'}>
                <div
                    className={"bg-white bg-modal bg-top bg-cover max-w-[950px] md:max-h-[95vh] md:mx-auto relative md:rounded-xl p-10 md:px-24 md:pb-6 md:pt-2 2xl:pt-6 md:overflow-y-auto rounded-lg m-5"}>
                    <button onClick={() => {
                        setModal({
                            dayId: null,
                            isVisible: false
                        })
                        setLastOpenedBox(day)
                    }}><img src="assets/images/X.png" alt="" className={'absolute right-5 top-5'}/>
                    </button>
                    {content[0].content}
                    {day === "9" && <div className={"h-[200px] w-full flex gp-5 md:gap-20 items-end mb-10"}>
                        <div className={"bg-red-500 w-full h-0"} style={{ height: `${percent0}%` }}></div>
                        <div className={"bg-blue-500 w-full h-0"} style={{ height: `${percent1}%` }}></div>
                    </div>}
                    {(day === "9" && !voted) && <div className={"flex w-full gap-5 md:gap-20 items-end mb-10"}>
                        <div className={"w-full flex justify-center"}>
                            <button className={"btn-primary"} onClick={() => vote(0)}>Bejglire szavazok</button>
                        </div>
                        <div className={"w-full flex justify-center"}>
                            <button className={"btn-primary"} onClick={() => vote(1)}>Zserbóra szavazok</button>
                        </div>
                    </div>}
                    {(day === "9" && !!voted) && <div className={"flex w-full gap-5 md:gap-20 items-end mb-10"}>
                        <div className={"w-full flex justify-center"}>
                            <h3>Bejgli</h3>
                        </div>
                        <div className={"w-full flex justify-center"}>
                            <h3>Zserbó</h3>
                        </div>
                    </div>}
                </div>
            </div>
        </>
    );
};

export default Modal;
